import "../styles/testimonial.css";
import "swiper/css";
import "swiper/css/pagination";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import { useEffect, useState } from "react";

import lokesh from "../images/testimonial(2).png";
import suraj from "../images/testimonial(1).png";
import ajay from "../images/testimonial(3).png";
import shubham from "../images/testimonial(4).png";
import ishika from "../images/testimonial(5).png";
import sapna from "../images/testimonial(6).png";

export default function Testimonial() {
	const [slides, setslides] = useState(2);

	useEffect(() => {
		setslides(getSlidesPerView(window.innerWidth));
		window.addEventListener("resize", () => {
			setslides(getSlidesPerView(window.innerWidth));
		});
	}, []);
	function getSlidesPerView(width) {
		let slides;
		if (width <= 500) {
			slides = 1;
		} else if (width <= 800) {
			slides = 2;
		} else if (width <= 1360) {
			slides = 3;
		} else slides = 4;
		return slides;
	}
	SwiperCore.use([Pagination, Autoplay]);

	return (
		<>
			<section className="testimonial" id="testimonial">
				<span className="section__subtitle">My friends say</span>
				<h2 className="section__title">Testimonial</h2>
				<div className="testimonial__container container">
					<Swiper
						spaceBetween={24}
						slidesPerView={slides}
						loop={true}
						grabCursor={true}
						pagination={{ clickable: true, el: ".swiper-pagination" }}
						autoplay={{ delay: 2500, disableOnInteraction: false }}
					>
						<SwiperSlide>
							<div className="testimonial__card">
								<img src={sapna} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Sapna Maurya</h3>
								<p className="testimonial__description">
									I have worked with Vaibhav on more in 2 projets as a content
									writer, he is very understanding an Serious towards his work
								</p>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className="testimonial__card">
								<img src={suraj} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Suraj Manwal</h3>
								<p className="testimonial__description">
									Always available to help, extremely knowledgeable, matched
									deadline, hardworking and reliable.
								</p>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className="testimonial__card">
								<img src={lokesh} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Lokesh Rawat</h3>
								<p className="testimonial__description">
									Expecting to work together again. It was fun working with you,
									we made a good project.
								</p>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className="testimonial__card">
								<img src={ishika} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Ishika Mamgain</h3>
								<p className="testimonial__description">
									Vaibhav has a calm nature and he is focused towards his work
								</p>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className="testimonial__card">
								<img src={ajay} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Mr. A.J Vishwkarma</h3>
								<p className="testimonial__description">
									I was looking for a web professional to create and develop my
									website. Vaibhav delivered exactly what I want. It's always a
									pleasure working with him and seeing him.
								</p>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className="testimonial__card">
								<img src={shubham} alt="" className="testimonial__img" />
								<h3 className="testimonial__name">Shubham Maurya</h3>
								<p className="testimonial__description">
									We worked on a really simple and small project but you were
									still so exited, appreciate that.
								</p>
							</div>
						</SwiperSlide>
					</Swiper>
					<div className="swiper-pagination"></div>
				</div>
			</section>
		</>
	);
}
